import { useParams } from "react-router-dom";

const BasicInfo = () => {
    const { network, name } = useParams();

    return (
        <>
            <div>
                <h1>
                    {network.charAt(0).toUpperCase() + network.slice(1)} -{" "}
                    {name.charAt(0).toUpperCase() + name.slice(1)} Blockchain
                </h1>
                {/* Add more detailed information about the blockchain 
					We can also use another section for templates in case we need to format some differently.
					An example is below this with Information and Support like we did in the About Me page.*/}
            </div>
            {/* <Information />
        <Support /> */}
        </>
    );
};

export default BasicInfo;
